import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
	planStepByRoute,
	planNextStep,
	planPrevStep,
	isPlanGuideRoute,
} from '../../data/touristNavigation';
import PlanStepsRail from './PlanStepsRail';
import '../../styles/tourist-nav.scss';

function TouristPlanNav() {
	const { pathname } = useLocation();

	if (!isPlanGuideRoute(pathname)) return null;

	const activeStep = planStepByRoute(pathname);
	const activeId = activeStep?.id;
	const prev = activeId ? planPrevStep(activeId) : null;
	const next = activeId ? planNextStep(activeId) : null;

	return (
		<nav className="plan-page-nav" aria-label="Plan your trip">
			<div className="plan-page-nav__meta container">
				<div className="plan-page-nav__crumb">
					<Link to="/">Home</Link>
					<span aria-hidden="true">/</span>
					<Link to="/#plan">Plan</Link>
					{activeStep && (
						<>
							<span aria-hidden="true">/</span>
							<span className="plan-page-nav__here" aria-current="page">{activeStep.label}</span>
						</>
					)}
				</div>
				<div className="plan-page-nav__arrows">
					{prev ? (
						<Link to={prev.route} className="plan-page-nav__arrow plan-page-nav__arrow--prev">
							← {prev.label}
						</Link>
					) : (
						<Link to="/#plan" className="plan-page-nav__arrow plan-page-nav__arrow--prev">
							← All topics
						</Link>
					)}
					{next && (
						<Link to={next.route} className="plan-page-nav__arrow plan-page-nav__arrow--next">
							{next.label} →
						</Link>
					)}
				</div>
			</div>
			<div className="plan-page-nav__rail-wrap container">
				<PlanStepsRail activeStepId={activeId} />
			</div>
		</nav>
	);
}

export default TouristPlanNav;
